import { render } from "./diseaseSearch.vue?vue&type=template&id=94d2e9f0&scoped=true"
import script from "./diseaseSearch.vue?vue&type=script&lang=js"
export * from "./diseaseSearch.vue?vue&type=script&lang=js"

import "./diseaseSearch.vue?vue&type=style&index=0&id=94d2e9f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94d2e9f0"]])

export default __exports__